"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var yup = _interopRequireWildcard(require("yup"));

var _reactRouterDom = require("react-router-dom");

var _ramda = require("ramda");

var _reactConfirmAlert = require("react-confirm-alert");

var _Button = _interopRequireDefault(require("./Button"));

var _withFormWrapper = _interopRequireDefault(require("./hocs/withFormWrapper"));

var _Radio = require("./formComponents/Radio");

var _Checkboxes = require("./formComponents/Checkboxes");

var _Ranging = _interopRequireDefault(require("./formComponents/Ranging"));

var _Textarea = require("./formComponents/Textarea");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 15px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    color: #a0a0a0;\n    @media (max-width: 767px) {\n        margin-bottom: 15px;\n        font-size: 13px;\n        order: 0;\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 10px 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    @media (max-width: 767px) {\n        padding: 10px 0;\n        flex-wrap: wrap;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    color: #000;\n    background-color: transparent;\n    font-weight: 300;\n    text-align: center;\n    touch-action: manipulation;\n    cursor: pointer;\n    border: 1px solid #2b3d4f;\n    white-space: nowrap;\n    margin-left: 5px;\n    padding: 10px 16px;\n    font-size: 18px;\n    line-height: 1.33;\n    &:focus {\n        outline: none;\n    }\n    &:hover {\n        background-color: #2b3d4f;\n        color: #fff;\n    }\n    @media (max-width: 767px) {\n        order: 1;\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border-bottom: 4px solid #ededed;\n    padding: 10px 15px 15px;\n    @media (max-width: 767px) {\n        padding: 10px 0px 15px;\n        border: 0;\n        .form-item {\n            .mb-4 {\n                margin-bottom: 10px;\n            }\n        }\n    }\n    label {\n        display: inline-block;\n        font-size: 17px;\n        @media (max-width: 767px) {\n            font-size: 16px;\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var FieldContainer = _styledComponents["default"].div(_templateObject());

var SubmitButton = (0, _styledComponents["default"])(_Button["default"])(_templateObject2());

var GrayButton = _styledComponents["default"].button(_templateObject3());

var Footer = _styledComponents["default"].div(_templateObject4());

var Help = _styledComponents["default"].div(_templateObject5());

var PauseField = _styledComponents["default"].div(_templateObject6());

var QUESTIONS_HELP_TEXT = {
  'drag': ''
};

var QuestionForm = /*#__PURE__*/function (_Component) {
  _inherits(QuestionForm, _Component);

  var _super = _createSuper(QuestionForm);

  function QuestionForm() {
    var _this;

    _classCallCheck(this, QuestionForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderHelp", function () {
      var _this$props = _this.props,
          data = _this$props.data,
          translate = _this$props.translate;

      switch (data.type) {
        case 'choice':
          return data.multipleAnswers ? (0, _ramda.path)(['questionHelp', "".concat(data.type, "s")], translate) : (0, _ramda.path)(['questionHelp', data.type], translate);

        case 'ranging':
          return (0, _ramda.path)(['questionHelp', data.type], translate);

        case 'open':
          return (0, _ramda.path)(['questionHelp', data.type], translate);

        default:
          return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderField", function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          colors = _this$props2.colors,
          _this$props2$translat = _this$props2.translate,
          translate = _this$props2$translat === void 0 ? {} : _this$props2$translat,
          isAudit = _this$props2.isAudit;

      switch (data.type) {
        case 'choice':
          var options = data.answerVariants || [];
          return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
            name: data.multipleAnswers ? 'answerVariantIds' : 'answerVariantId',
            component: data.multipleAnswers ? _Checkboxes.Checkboxes : _Radio.Radio,
            options: options,
            namePath: "title",
            inline: false,
            colors: colors,
            initialValue: isAudit ? data.multipleAnswers ? options.filter((0, _ramda.prop)('correct')).map((0, _ramda.prop)('id')) : (0, _ramda.prop)('id', options.find((0, _ramda.prop)('correct'))) : undefined,
            isAudit: isAudit,
            disabled: isAudit
          });

        case 'ranging':
          var variants = data.answerVariants || [];
          return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
            name: "answerVariantIds",
            component: _Ranging["default"],
            colors: colors,
            placeholderMessage: (0, _ramda.path)(['rangingPlaceholderMessage'], translate),
            initialValue: isAudit ? (0, _ramda.sortBy)((0, _ramda.prop)('rank'), variants).map((0, _ramda.prop)('id')) : undefined,
            options: variants,
            isAudit: isAudit,
            disabled: isAudit
          });

        case 'open':
          return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
            name: "answer",
            component: _Textarea.Textarea,
            colors: colors,
            initialValue: isAudit ? (0, _ramda.path)(['auditOpenAnswerMessage'], translate) || 'Свободный ответ' : undefined,
            isAudit: isAudit,
            disabled: isAudit
          });

        default:
          return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "finishTest", function () {
      var _this$props$translate = _this.props.translate,
          translate = _this$props$translate === void 0 ? {} : _this$props$translate;
      (0, _reactConfirmAlert.confirmAlert)({
        title: (0, _ramda.path)(['confirmTitleMessage'], translate) || 'Завершение теста',
        message: (0, _ramda.path)(['confirmMessage'], translate) || 'Вы уверены, что хотите завершить тест?',
        buttons: [{
          label: (0, _ramda.path)(['confirmOkMessage'], translate) || 'Да',
          onClick: _this.props.finishTest
        }, {
          label: (0, _ramda.path)(['confirmCancelMessage'], translate) || 'Отмена'
        }]
      });
    });

    return _this;
  }

  _createClass(QuestionForm, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          respondent = _this$props3.respondent,
          invalid = _this$props3.invalid,
          isAudit = _this$props3.isAudit,
          skipUrl = _this$props3.skipUrl,
          history = _this$props3.history,
          pauseAllowed = _this$props3.pauseAllowed,
          colors = _this$props3.colors,
          additionalFormFields = _this$props3.additionalFormFields,
          formAction = _this$props3.formAction,
          pagination = _this$props3.pagination,
          translate = _this$props3.translate;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "answer"
      }, /*#__PURE__*/_react["default"].createElement(FieldContainer, null, this.renderField()), additionalFormFields, pauseAllowed && /*#__PURE__*/_react["default"].createElement(PauseField, null, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
        name: "pauseAfterQuestion",
        component: _Checkboxes.Checkbox,
        text: (0, _ramda.path)(['nextPauseMessage'], translate) || 'Поставить на паузу после данного вопроса'
      })), /*#__PURE__*/_react["default"].createElement(Footer, null, skipUrl ? /*#__PURE__*/_react["default"].createElement(GrayButton, {
        type: "button",
        onClick: function onClick() {
          return history.push(skipUrl);
        }
      }, (0, _ramda.path)(['skipMessage'], translate) || 'Пропустить') : null, !isAudit && (0, _ramda.path)(['questionHelp', data.type], translate) ? /*#__PURE__*/_react["default"].createElement(Help, null, this.renderHelp()) : /*#__PURE__*/_react["default"].createElement(Help, null), /*#__PURE__*/_react["default"].createElement(SubmitButton, {
        type: "submit",
        disabled: invalid || (0, _ramda.path)(['meta', 'pending'], formAction),
        bg: colors.input,
        id: "answer"
      }, (0, _ramda.path)(['submitMessage'], translate) || 'Ответить'))), pagination, !isAudit && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row-reverse',
          padding: 15
        }
      }, /*#__PURE__*/_react["default"].createElement(GrayButton, {
        type: "button",
        onClick: this.finishTest
      }, (0, _ramda.path)(['finishMessage'], translate) || 'Завершить тест'), respondent && respondent.showPublicTestsLinkInTest && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: "/tests/".concat(respondent.slug, "/").concat(respondent.code || respondent.email)
      }, /*#__PURE__*/_react["default"].createElement(GrayButton, null, (0, _ramda.path)(['testsLink'], translate) || 'Перейти к списку тестов'))));
    }
  }]);

  return QuestionForm;
}(_react.Component);

var validationSchema = function validationSchema(_ref) {
  var data = _ref.data,
      isAudit = _ref.isAudit;
  var isRanging = data.type === 'ranging';
  var answerValidation = data.type === 'open' ? {
    answer: yup.string().required()
  } : data.multipleAnswers || isRanging ? {
    answerVariantIds: yup.array().min(isRanging ? data.answerVariants.length : 1).required()
  } : {
    answerVariantId: yup.string().required()
  };
  return yup.object().shape(_objectSpread({}, isAudit ? {
    complexity: yup.string().nullable().required(),
    incorrectQuestion: yup.bool().nullable().required(),
    incorrectRightAnswer: yup.bool().nullable(),
    obviousAnswers: yup.bool().nullable(),
    sameQuestion: yup.bool().nullable(),
    wrongCategory: yup.bool().nullable(),
    incorrectQuestionText: yup.bool().when(['incorrectQuestion', 'incorrectRightAnswer', 'obviousAnswers', 'sameQuestion', 'wrongCategory'], {
      is: function is(incorrectQuestion, incorrectRightAnswer, obviousAnswers, sameQuestion, wrongCategory) {
        return incorrectQuestion ? !incorrectRightAnswer && !obviousAnswers && !sameQuestion && !wrongCategory : false;
      },
      then: yup.bool().oneOf([true]).required(),
      otherwise: yup.bool().nullable()
    })
  } : answerValidation));
};

var _default = (0, _reactRouterDom.withRouter)((0, _withFormWrapper["default"])(QuestionForm, {
  validationSchema: validationSchema,
  enableReinitialize: true,
  mapPropsToValues: (0, _ramda.prop)('initialValues'),
  mapBeforeSubmit: function mapBeforeSubmit(values, _ref2) {
    var setPaused = _ref2.setPaused,
        isAudit = _ref2.isAudit;

    if (values.pauseAfterQuestion) {
      setPaused(true);
    }

    return _objectSpread(_objectSpread(_objectSpread({}, values), isAudit ? {
      incorrectQuestion: !!values.incorrectQuestion,
      incorrectQuestionText: !!values.incorrectQuestionText,
      incorrectRightAnswer: !!values.incorrectRightAnswer,
      obviousAnswers: !!values.obviousAnswers,
      sameQuestion: !!values.sameQuestion,
      wrongCategory: !!values.wrongCategory
    } : {}), {}, {
      finishAfterAnswer: values.finishAfterAnswer && !values.pauseAfterQuestion
    });
  }
}));

exports["default"] = _default;